import { useDispatch } from "react-redux";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { handleResErrors } from "./utils";
import axiosInstance from "../config/Axios";
import { setCompanyTags } from "../redux/Slices/Global/globalSlice";
import { useDataTableContext } from "../pages/Contexts/DataTableContext";
import { PLAYLISTS_TABLE_CONFIG } from "../Constants/datatables";




//--------------------------get all tags--------------------------

const getCompanyTags = async ({ queryKey }) => {
    const [, searchTerm] = queryKey;
    let url = `/tag/all`;

    if (searchTerm) {
        url += `?search=${encodeURIComponent(searchTerm)}`;
    }

    const { data } = await axiosInstance.get(url);

    return data.data;
}

export const useGetCompanyTags = (searchTerm = '') => {
    const { showToast } = useCustomToast();
    const dispatch = useDispatch()
    let { isLoading, data, isFetching, refetch } = useQuery(
        ['getCompanyTags', searchTerm],
        getCompanyTags,
        {
            keepPreviousData: true,
            staleTime: 1000 * 60 * 5,
            refetchOnWindowFocus: false,

            onSuccess: async (data) => {
                dispatch(setCompanyTags(data))

            },
            onError: (error) => {
                showToast("error", "Fetching Data", error.response?.data?.message);
            },
        }
    );

    return { isLoading, data, refetch, isFetching };
}



//--------------------------Create tag--------------------------
const createTag = async (payload) => {
    const { data } = await axiosInstance.post("/tag/create", payload);
    return data.data;
}

export const useCreateTagMutation = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createTag,
        onSuccess: async (data, variables) => {
            queryClient.invalidateQueries(['getPlaylist', variables.tagged_id]);
            queryClient.invalidateQueries({ queryKey: ["companyPlaylists"] });
            queryClient.invalidateQueries({ queryKey: ["getCompanyTags"] });

            // showToast('success', "tag Handling", data?.msg);
        },
        onError: (error) => handleResErrors(error, showToast),
    });
};

//--------------------------Detach tag --------------------------
const detachTag = async (payload) => {
    const { data } = await axiosInstance.delete(`/tag/${payload.tag_id}/${payload.tagged_id}/detach`);
    return data.data;
}

export const useDetachTag = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();

    return useMutation(detachTag, {
        onSuccess: async (result, variables) => {
            queryClient.invalidateQueries(['getPlaylist', variables.tagged_id]);
            queryClient.invalidateQueries({ queryKey: ["companyPlaylists"] });
            queryClient.invalidateQueries({ queryKey: ["getCompanyTags"] });

        },
        onError: (error) => handleResErrors(error, showToast)
    })
}

// -------------------------- update playlist tag --------------------------
const updatePlaylistTag = async (payload) => {
    const { data } = await axiosInstance.put(`/tag/${payload.tagged_id}/update`, payload);
    return data.data;
};

export const useUpdatePlaylistTag = () => {
    const { showToast } = useCustomToast();
    const queryClient = useQueryClient();
    const { setLazyParams } = useDataTableContext();

    return useMutation(updatePlaylistTag, {
        onSuccess: async (result, variables) => {
            // queryClient.invalidateQueries(['getPlaylist', variables.tagged_id]);
            showToast('success', 'Tags updated successfully');
            // setLazyParams(prev => ({ ...prev, ...PLAYLISTS_TABLE_CONFIG }))
            queryClient.invalidateQueries({ queryKey: ["companyPlaylists"] });
            queryClient.invalidateQueries({ queryKey: ["getCompanyTags"] });

        },
        onError: (error) => handleResErrors(error, showToast)
    });
};

